import i18n from 'i18next';

import { DashboardVehicle } from '../types/DashboardVehicle';
import { getVehicleBrand } from './getVehicleBrand';
import { isVehicleApplicationInSubmission } from './isVehicleApplicationInSubmission';

const AUTOPAY_NUMBER_DISPLAY_OFFSET = 6;

export const getVehicleApplicationDescription = (
  vehicle: DashboardVehicle,
): string => {
  if (isVehicleApplicationInSubmission(vehicle)) {
    return i18n.t('applicationDescription.inSubmission');
  }

  const brand = getVehicleBrand(vehicle);
  const id = vehicle.application?.autopayNumber?.substring(
    AUTOPAY_NUMBER_DISPLAY_OFFSET,
  );

  if (!id) {
    return i18n.t('applicationDescription.brand', { brand });
  }

  return i18n.t('applicationDescription.brandWithId', { brand, id });
};
